interface RadiusSelectorProps {
  value: 1 | 3 | 5 | 10
  onChange: (radius: 1 | 3 | 5 | 10) => void
}

const RADIUS_OPTIONS: (1 | 3 | 5 | 10)[] = [1, 3, 5, 10]

/**
 * Horizontal button group for selecting search radius in miles.
 * Options: 1 mi | 3 mi | 5 mi | 10 mi
 * Active option highlighted with green accent color.
 */
export function RadiusSelector({ value, onChange }: RadiusSelectorProps) {
  return (
    <div className="flex gap-2">
      {RADIUS_OPTIONS.map((radius) => (
        <button
          key={radius}
          onClick={() => onChange(radius)}
          className={`flex-1 py-3 px-3 rounded-lg text-sm font-medium transition-colors min-h-[48px] ${
            value === radius
              ? 'bg-brand-500 text-white shadow-sm'
              : 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700'
          }`}
          aria-pressed={value === radius}
        >
          {radius} mi
        </button>
      ))}
    </div>
  )
}
